module.exports = __webpack_public_path__ + "media/images/dashboard-3d60e2a34ec00a54cc1d9d3abb68307a.svg";